// extracted by mini-css-extract-plugin
export default {"title":"style--title--f21c1f"};